{
  "dashboard-sidebar-support-resources-tooltip": "Click here for answers or to submit a support request.",
  "dashboard-sidebar-support-help-center": "Help Center",
  "dashboard-sidebar-support-getting-started-video": "Getting Started Video",
  "dashboard-sidebar-support-help-button-label": "Help",
  "dashboard-sidebar-support-help-button-unread-count": "Help, {{count}} unread product updates",
  "dashboard-sidebar-support-help-button-unread-count_one": "Help, 1 unread product update",
  "dashboard-sidebar-support-help-button-unread-count_other": "Help, {{count}} unread product updates",
  "dashboard-sidebar-support-whats-new": "What's New",
  "dashboard-sidebar-support-whats-new-unread-count": "{{count}} unread product updates",
  "dashboard-sidebar-support-whats-new-unread-count_one": "1 unread product update",
  "dashboard-sidebar-support-whats-new-unread-count_other": "{{count}} unread product updates",

  "global-search-open": "Open global search",
  "global-search-hide": "Hide global search trigger",
  "global-search-show": "Show global search",
  "global-search-dialog-label": "Global search",
  "global-search-close": "Close search",
  "global-search-input-label": "Search clients, settings, and integrations",
  "global-search-placeholder": "Search clients, settings, integrations",
  "global-search-results-label": "Search results",
  "global-search-section-destinations": "Destinations",
  "global-search-section-clients": "Clients",
  "global-search-account-settings-title": "Account Settings",
  "global-search-account-settings-detail": "Manage your advisor account, email, password, and MFA.",
  "global-search-firm-settings-title": "Firm Settings",
  "global-search-firm-settings-detail": "Manage firm details, team configuration, Elements Labs, and templates.",
  "global-search-integrations-title": "Integrations",
  "global-search-integrations-detail": "Browse available integrations and connection options.",
  "global-search-baa-title": "Morningstar / BAA",
  "global-search-baa-detail": "Open the Morningstar ByAllAccounts integration.",
  "global-search-your-household": "Your household",
  "global-search-client-household": "Client household",
  "global-search-archived-client-household": "Archived client household",
  "global-search-loading-clients": "Loading clients...",
  "global-search-client-error": "Clients could not be loaded. Try again.",
  "global-search-client-partial-error": "Some clients could not be loaded. Try again.",
  "global-search-no-results": "No results found",

  "welcome-modal-title": "Getting Started with Elements",
  "welcome-modal-body": "Welcome to Elements! Watch this video to learn all the basics about how Elements can help you and your clients quickly assess their financial health.",
  "welcome-modal-video-title": "Welcome to Elements",
  "welcome-modal-video-thumbnail-alt": "Getting Started Video Thumbnail",

  "custom-groups-section-title": "Custom Groups",
  "custom-groups-create-modal-title": "New Custom Group",
  "custom-groups-create-name-label": "Group Name",
  "custom-groups-create-name-placeholder": "Required",
  "custom-groups-create-error": "Unable to create custom group",
  "custom-groups-delete-group": "Delete Group",
  "custom-groups-delete-confirmation-title": "Delete “{{- groupName}}” Custom Group?",
  "custom-groups-delete-confirmation-body": "Deleting this group cannot be undone. All clients currently in this group will be unassigned.",
  "custom-groups-delete-confirmation-button": "Delete Custom Group",
  "custom-groups-delete-error": "Unable to delete group",
  "custom-groups-rename-group": "Rename Group",
  "custom-groups-rename-modal-title": "Rename Custom Group",
  "custom-groups-rename-error": "Unable to rename group",

  "insights-title": "Insights",
  "insights-refresh": "Refresh insights",
  "insights-refreshing": "Refreshing…",
  "insights-refresh-no-change": "Snapshot reloaded. No new insights.",
  "insights-refresh-updated": "Snapshot reloaded. Insights updated.",
  "insights-refresh-error": "Couldn't reload Insights. Showing the last saved assessment snapshot.",
  "insights-snoozed-status": "{{- household}} snoozed for this session.",
  "insights-dismissed-status": "{{- household}} dismissed for this session.",
  "insights-undo": "Undo",
  "insights-loading": "Reviewing saved assessments…",
  "insights-load-error": "We couldn't load Insights.",
  "insights-load-error-helper": "Try again to review the firm's latest saved client assessments.",
  "insights-try-again": "Try again",
  "insights-empty": "No Insights from the latest saved assessment snapshot.",
  "insights-empty-helper": "Elements will surface explainable opportunities here when saved client data meets a reviewed Insight rule.",
  "insights-caught-up": "You're caught up for this session.",
  "insights-caught-up-helper": "You snoozed or dismissed every current Insight. These choices reset when you reload the page.",
  "insights-queue-label": "Insights queue",
  "insights-queue-title": "Prioritized insights",
  "insights-current-snapshot": "Latest saved assessment snapshot",
  "insights-detail-label": "Selected Insight",
  "insights-back": "Back to insights",
  "insights-view-insight": "View insight",
  "insights-view-insight-label": "View {{- household}} {{- element}} Insight",
  "insights-view-client": "View client",
  "insights-snooze": "Snooze",
  "insights-dismiss": "Dismiss",
  "insights-triage-label": "{{- action}} {{- household}} Insight",
  "insights-current-score": "Saved Element score",
  "insights-score-unavailable": "Saved score unavailable",
  "insights-evidence-title": "Evidence",
  "insights-why-title": "Why this may matter",
  "insights-verify-title": "Fact to verify",
  "insights-next-title": "Suggested next action",

  "insights-condition-liquidity": "Liquid savings cover less than six months of expenses.",
  "insights-condition-savings": "Annual savings are below 10% of income.",
  "insights-condition-debt": "Debt payments exceed 30% of income.",
  "insights-condition-debt-over-savings": "Debt payments are higher than annual savings.",
  "insights-condition-coverage": "Known insurance coverage is below the saved calculated need.",
  "insights-condition-real-estate": "Real estate represents more than half of net worth.",
  "insights-condition-business": "Business equity represents more than half of net worth.",
  "insights-condition-tax": "The effective tax rate is above 35%.",

  "insights-evidence-liquidity-compact": "{{liquidity}} liquid · {{months}} months of expenses",
  "insights-evidence-savings-compact": "{{savings}} saved · {{rate}} of income",
  "insights-evidence-debt-compact": "{{payments}} in payments · {{rate}} of income",
  "insights-evidence-debt-over-savings-compact": "{{payments}} debt payments · {{savings}} savings",
  "insights-evidence-coverage-compact": "{{coverage}} minimum known coverage · {{coverageTypes}}",
  "insights-evidence-concentration-compact": "{{equity}} in equity · {{rate}} of net worth",
  "insights-evidence-tax-compact": "{{rate}} effective rate · {{year}} tax year",

  "insights-label-liquid-savings": "Liquid savings",
  "insights-label-annual-expenses": "Annual expenses",
  "insights-label-months-covered": "Months covered",
  "insights-label-annual-savings": "Annual savings",
  "insights-label-annual-income": "Annual income",
  "insights-label-savings-rate": "Savings rate",
  "insights-label-annual-debt-payments": "Annual debt payments",
  "insights-label-debt-to-income": "Debt payments / income",
  "insights-label-known-coverage": "Minimum known coverage",
  "insights-label-coverage-types": "Coverage types below need",
  "insights-label-real-estate-equity": "Real estate equity",
  "insights-label-business-equity": "Business equity",
  "insights-label-net-worth": "Net worth",
  "insights-label-share-of-net-worth": "Share of net worth",
  "insights-label-taxes-paid": "Taxes paid",
  "insights-label-taxed-income": "Taxed income",
  "insights-label-effective-tax-rate": "Effective tax rate",
  "insights-label-tax-year": "Tax year",

  "insights-coverage-life": "Life",
  "insights-coverage-disability": "Disability",
  "insights-coverage-liability": "Liability",

  "insights-why-liquidity": "A thinner cash reserve may limit flexibility when expenses or income change.",
  "insights-verify-liquidity": "Confirm these liquid assets and annual expenses are current.",
  "insights-next-liquidity": "Review an appropriate liquidity range and one step to close the gap.",
  "insights-why-savings": "Current savings may not be enough to support the household's stated priorities.",
  "insights-verify-savings": "Confirm current income and automatic contributions.",
  "insights-next-savings": "Identify one contribution change the household could sustain.",
  "insights-why-debt": "Debt payments may be limiting monthly flexibility.",
  "insights-verify-debt": "Confirm recurring debt payments and whether any will end soon.",
  "insights-next-debt": "Prioritize the highest-cost debt or refinance opportunity.",
  "insights-why-debt-over-savings": "More cash is going to debt than savings, which may slow progress toward goals.",
  "insights-verify-debt-over-savings": "Confirm whether extra debt payments are intentional and temporary.",
  "insights-next-debt-over-savings": "Compare the next dollar toward debt versus savings.",
  "insights-why-coverage": "A known coverage gap may leave part of the household's risk unprotected.",
  "insights-verify-coverage": "Confirm benefits, policy details, and current coverage needs.",
  "insights-next-coverage": "Review the uncovered need and decide whether an insurance conversation is warranted.",
  "insights-why-real-estate": "Concentrated real estate equity may reduce liquidity and diversification.",
  "insights-verify-real-estate": "Confirm current property values, debt, and intended holding period.",
  "insights-next-real-estate": "Discuss whether liquidity or diversification should be part of the next review.",
  "insights-why-business": "Concentrated business equity may tie financial security to one asset.",
  "insights-verify-business": "Confirm valuation, ownership percentage, and exit expectations.",
  "insights-next-business": "Identify one risk-management or liquidity-planning conversation.",
  "insights-why-tax": "A higher effective tax rate may create planning opportunities.",
  "insights-verify-tax": "Confirm the latest return and whether the tax year is representative.",
  "insights-next-tax": "Review withholding, deductions, and timing opportunities with the client's tax professional.",

  "insights-draft-outreach": "Draft outreach",
  "insights-outreach-title": "Outreach draft",
  "insights-outreach-subject-label": "Subject",
  "insights-outreach-message-label": "Message",
  "insights-outreach-helper": "Review and edit this draft before sharing. Nothing is sent from Elements.",
  "insights-outreach-subject-template": "A quick follow-up on your Elements assessment",
  "insights-outreach-template": "Hi {{- household}},\n\nI was reviewing your latest saved Elements assessment and found an item worth discussing: {{- condition}}\n\nBefore we decide whether any change is needed, I'd like to confirm the underlying figures with you. {{- nextAction}}\n\nWould you be open to a quick conversation?\n\nBest,",
  "insights-copy-draft": "Copy draft",
  "insights-copy-template": "Subject: {{- subject}}\n\n{{- body}}",
  "insights-copy-success": "Draft copied.",
  "insights-copy-error": "Couldn't copy the draft. Select the text and copy it manually.",
  "household-insights-heading": "Insights",
  "household-insights-email": "Email",
  "household-insights-talk-track": "Talk track",
  "household-insights-copy-email": "Copy email text",
  "household-insights-copy-subject": "Copy subject",
  "household-insights-copying": "Copying…",
  "household-insights-subject-copied": "Subject copied.",
  "household-insights-email-copied": "Email text copied.",
  "household-insights-copy-failed": "Couldn’t copy. Your draft is still here—select the text and copy it manually.",
  "household-insights-draft-changed": "The figures have changed. Your edits are preserved; review this draft against the evidence before sharing.",
  "household-insights-talk-open": "Open",
  "household-insights-talk-question": "Ask",
  "household-insights-talk-nextStep": "Next step",
  "household-insights-why": "Why this?",
  "household-insights-evidence-note": "Based on saved financial inputs. Confirm these figures before using the draft.",
  "household-insights-other": "Other insights",
  "household-insights-empty": "No conversation topics from the saved financial inputs. This does not mean every area has been reviewed.",
  "household-insights-undo": "Undo",
  "household-insights-session-note": "Draft edits, snoozes and dismissals last for this visit. Nothing is sent from Elements.",
  "household-insights-snooze-status": "Snoozed for this visit.",
  "household-insights-dismiss-status": "Dismissed for this visit.",
  "household-insights-load-failed": "Couldn’t refresh the financial inputs. Any previous view is still shown. Try Refresh insights again.",
  "household-insights-loading": "Loading household insights…",
  "household-insights-email-template": "Hi,\n\n{{- open}} {{- question}}\n\n{{- nextStep}} Let me know what you have in mind, and we can work through it together.\n\nBest,",
  "household-insights-liquidity-title": "Check in about upcoming cash needs",
  "household-insights-liquidity-subject": "A quick check on your upcoming plans",
  "household-insights-liquidity-open": "I’d like to make sure the cash you have available fits your upcoming plans.",
  "household-insights-liquidity-question": "What upcoming plans or expenses would you like your cash to cover?",
  "household-insights-liquidity-next": "Together, we can decide how much to keep available.",
  "household-insights-liquidity-meeting-title": "Cash for what’s next",
  "household-insights-savings-title": "Find room for what matters next",
  "household-insights-savings-subject": "Checking in on your savings plans",
  "household-insights-savings-open": "I’d like to check how your savings fit the things you want to work toward.",
  "household-insights-savings-question": "What would you most like your savings to make possible?",
  "household-insights-savings-next": "Together, we can choose a savings amount that fits your priorities.",
  "household-insights-savings-meeting-title": "Saving for what matters",
  "household-insights-debt-title": "Review how debt payments fit",
  "household-insights-debt-subject": "A check on your monthly commitments",
  "household-insights-debt-open": "I’d like to look at how debt payments fit alongside your other priorities.",
  "household-insights-debt-question": "How do your current payments affect the flexibility you want?",
  "household-insights-debt-next": "Together, we can review the options before deciding what to change.",
  "household-insights-debt-meeting-title": "Room in your cash flow",
  "household-insights-debtOverSavings-title": "Balance debt payments and saving",
  "household-insights-debtOverSavings-subject": "Balancing payments and savings",
  "household-insights-debtOverSavings-open": "I’d like to review the balance between debt payments and saving.",
  "household-insights-debtOverSavings-question": "Which matters most right now: reducing debt, building savings, or keeping more flexibility?",
  "household-insights-debtOverSavings-next": "Together, we can agree on a balance that fits your priorities.",
  "household-insights-debtOverSavings-meeting-title": "Payments and savings",
  "household-insights-coverage-title": "Check whether coverage still fits",
  "household-insights-coverage-subject": "A check on your insurance coverage",
  "household-insights-coverage-open": "I’d like to confirm that the coverage recorded in Elements reflects what you have today.",
  "household-insights-coverage-question": "What would you want your coverage to protect if life changed?",
  "household-insights-coverage-next": "Together, we can confirm the details and decide whether a closer review would help.",
  "household-insights-coverage-meeting-title": "Protecting what matters",
  "household-insights-realEstateConcentration-title": "Review the role of your properties",
  "household-insights-realEstateConcentration-subject": "How your properties fit your plans",
  "household-insights-realEstateConcentration-open": "I’d like to look at the role your properties play in your financial life.",
  "household-insights-realEstateConcentration-question": "What would you like these properties to make possible over time?",
  "household-insights-realEstateConcentration-next": "Together, we can review how your properties fit your wider plans.",
  "household-insights-realEstateConcentration-meeting-title": "Your properties and plans",
  "household-insights-businessConcentration-title": "Connect your business with your plans",
  "household-insights-businessConcentration-subject": "Your business and your financial plans",
  "household-insights-businessConcentration-open": "I’d like to look at how your business fits into your broader financial plans.",
  "household-insights-businessConcentration-question": "What role would you like your business to play in your future?",
  "household-insights-businessConcentration-next": "Together, we can identify what deserves a closer look.",
  "household-insights-businessConcentration-meeting-title": "Your business and your future",
  "household-insights-taxRate-title": "Put the recorded tax year in context",
  "household-insights-taxRate-subject": "A check on your tax picture",
  "household-insights-taxRate-open": "I’d like to confirm that the tax information recorded in Elements reflects your situation.",
  "household-insights-taxRate-question": "What has changed since the tax year we have on record?",
  "household-insights-taxRate-next": "Together, we can decide what to review with your tax professional.",
  "household-insights-taxRate-meeting-title": "Understanding your tax picture"
}
